import React, { useRef, useState } from "react";
import classNames from "classnames/bind";
import styles from "./StreamCam.module.css";
import { getColorForNotification } from "../../../../utils/helper";
import { useVideoPlayer } from "../../../../hooks/useVideoPlayer";
import { useCameraControls } from "../../../../hooks/useCameraControls";
import { useEventInfo } from "../../../../hooks/useEventInfo";
import { useCarParkMonitoring } from "../../../../hooks/useCarParkMonitoring";
import { useRegionDetection } from "../../../../hooks/useRegionDetection";
import CameraHeader from "./CameraHeader";
import CameraFooter from "./CameraFooter";
import CameraOverlays from "./CameraOverlays";
import VideoPlayer from "./VideoPlayer";

const cx = classNames.bind(styles);
const PlayerItem = ({
  item,
  screen,
  handleFullScreen,
  showOptions,
  nfc,
  hikEvent,
  restartCamera,
  getCountCarPark,
  isFullScreen,
  refreshCamera
}) => {
  // Refs
  const refWrapperVideo = useRef(null);

  // Local state
  const [reload, setReload] = useState(false);
  const [time, setTime] = useState(false);

  // Custom hooks for feature separation
  const { videoRef } = useVideoPlayer(item);
  const { isSound, binaryData, handleToggleSound } = useCameraControls(item, restartCamera);
  const eventInfo = useEventInfo(nfc, item, screen?.total);
  const { countPositionCarPart, showModalPositionCarPark, listPosition } = useCarParkMonitoring(
    item,
    nfc,
    getCountCarPark,
    refWrapperVideo,
    refreshCamera
  );
  const showModalRegion = useRegionDetection(item, refreshCamera);

  // Helper to check if notification exists for this camera
  const hasNotification = nfc.some((item1) => item1.code === item.code);
  const notificationColor = hasNotification
    ? getColorForNotification(nfc?.find((n) => n.code === item?.code)?.color)
    : null;

  return (
    <div className={cx("hover")}>
      {/* Notification border indicator */}
      <div
        className={cx("full-video")}
        style={
          hasNotification
            ? {
              borderImageSource: `linear-gradient(to bottom, ${notificationColor}, ${notificationColor})`,
              display: "block",
            }
            : {}
        }
      ></div>

      {/* Camera Header */}
      <CameraHeader
        item={item}
        screen={screen}
        isFullScreen={isFullScreen}
        nfc={nfc}
        isSound={isSound}
        handleToggleSound={handleToggleSound}
        handleFullScreen={handleFullScreen}
        showOptions={showOptions}
        restartCamera={restartCamera}
      />

      {/* Video Player */}
      <div className={cx("video-wrapper")} ref={refWrapperVideo}>
        <VideoPlayer
          item={item}
          videoRef={videoRef}
          binaryData={binaryData}
          time={time}
          reload={reload}
          setReload={setReload}
        />
      </div>

      {/* Camera Footer */}
      <CameraFooter
        item={item}
        screen={screen}
        isFullScreen={isFullScreen}
        hikEvent={hikEvent}
      />

      {/* All Overlays (Event Info, Car Park, Regions) */}
      <CameraOverlays
        eventInfo={eventInfo}
        countPositionCarPart={countPositionCarPart}
        showModalPositionCarPark={showModalPositionCarPark}
        showModalRegion={showModalRegion}
        screen={screen}
        isFullScreen={isFullScreen}
        item={item}
        listPosition={listPosition}
        refWrapperVideo={refWrapperVideo}
        refreshCamera={refreshCamera}
      />
    </div>
  );
};

export default React.memo(PlayerItem);
